<template>
  <div>
    
    <el-button size="mini" @click="localDialogVisible=true">
      录入询单
    </el-button>
    <el-dialog :visible.sync="localDialogVisible" @close="dialogClose">
      <template slot="title">
        <h2>创建当日未成交询单</h2>
        <p style="color: red">当日未成交询单当日创建</p>
      </template>
      <el-form :model="form" :rules="rules" ref="form">
        <el-form-item label="业务微信" prop="sellerwechat">
          <el-select value-key="ID" v-model="form.sellerwechat" @change="setNewClientForm" filterable placeholder="请选择">
            <el-option
              v-for="item in sellerlist"
              :key="item.ID"
              :label="item.SellerWechat"
              :value="item"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="客户微信" prop="client">
          <el-select
            v-model="form.client"
            filterable
            remote
            value-key="ID"
            reserve-keyword
            placeholder="请输入关键词"
            name="ClientWechat"
            :remote-method="getClientsOptions"
            :loading="optionsloading">
            <el-option
              v-for="item in clientOptions"
              :key="item.ID"
              :label="item.Client.ClientWechat"
              :value="item">
            </el-option>
            <div slot="empty">
              <div>
                未找到
              </div>
              <el-button @click="newdetailinputerdialog=true"
                         type="text">新增客户
              </el-button>
            </div>
          </el-select>
        </el-form-item>
        <el-form-item label="课程" prop="course">
          <course-input v-model="form.course" />
        </el-form-item>
        <el-form-item label="DUE" prop="due">
          <el-date-picker
            v-model="form.due"
            type="datetime"
            placeholder="选择日期时间">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="价格" prop="price">
          <el-input-number style="width: 150px" :min="0" :step-strictly="true" :controls="false" :step="0.01" v-model="form.price" placeholder="请输入价格" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit">
            提交
          </el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog
      destroy-on-close
      :visible.sync="newdetailinputerdialog"
      @close="newdetailinputerdialog=false"
    >
      <client-detail-inputer :wechatedit="inputerwechatedit" :form="newclientform"
                             @success="newclientdetail"></client-detail-inputer>
    </el-dialog>
  </div>
</template>

<script>
import ClientDetailInputer from "@/views/client/myclients/components/clientdetailinputer/index.vue";
import CourseInput from "@/components/CourseInput/index.vue";

export default {
  name: "index",
  components: {
    ClientDetailInputer,
    CourseInput,
  },
  props:{
    client: {
      type: Object,
      default: () => {
        return {
          Client: {
            ClientWechat: "",
          },
          ClientType: "student",
          ClientSchool: "",
          SellerWechat: "",
          Tag: "",
          Remark: "",
          ClientDetail: "",
          CourseList: [],
          Grades: [],
        }
      }
    },
    sellerwechat: {
      type: String,
      default: ''
    },
  },
  watch: {
    dialogVisible(newVal) {
      this.localDialogVisible = newVal; // 监听 prop 的变化并更新本地属性
    },
    client(newVal) {
      this.clientOptions = [newVal]
      this.form.client = newVal
    }
  },
  data() {
    var validateprice = (rule, value, callback) => {
      if (value < 0) {
        return callback(new Error('价格不能小于0'))
      } else {
        return callback()
      }
    }

    var validateSubject = (rule, value, callback) => {
      // console.log(this.orderform.course)
      // console.log(value)
      if (value.CourseCode === '') {
        return callback(new Error('输入课程代码'));
      }
      if (value.CourseName === '') {
        return callback(new Error('输入课程名'));
      }
      return callback()
    };
    return {
      clientOptions:[this.client],
      sellerlist: [],
      optionsloading: false,
      inputerwechatedit: true,
      newdetailinputerdialog: false,
      localDialogVisible: false,
      optionsLoading: false,
      options: [],
      form: {
        client: this.client,
        sellerwechat: this.sellerwechat,
        course:{CourseName:'',CourseCode:''},
        price:null,
        due: null,
      },
      newclientform: {
        ClientWechat: "",
        ClientType: "student",
        ClientSchool: "",
        SellerWechat: "",
        Tag: "",
        Remark: "",
        ClientDetail: "",
        CourseList: [],
        Grades: [],
      },
      rules: {
        course: [
          {required: true, message: '请输入学科名称'},
          {validator: validateSubject}
        ],
        client: [
          {required: true, message: '请输入客户微信号', trigger: 'blur'},
          // {validator: checkClient, trigger: 'blur'}
        ],
        sellerwechat: [
          {required: true, message: '请输入产生订单的业务微信号'}
        ],
        price: [
          {required: true, message: '请输入价格'},
          {validator: validateprice}
        ],
        due: [
          {required: true, message: '请输入到期时间'}
        ]
      }
    };
  },
  mounted() {
    this.$store.dispatch('order/getclientseller').then((respon) => {
      this.sellerlist = respon.data.sellers
    })
    // this.getClientsOptions()
  },
  methods: {
    cleanform() {
      this.form = {
        client: this.client,
        sellerwechat: this.sellerwechat,
        course:{CourseName:'',CourseCode:''},
        price:null,
        due: null,
      }
      this.newclientform = {
        ClientWechat: "",
        ClientType: "student",
        ClientSchool: "",
        SellerWechat: "",
        Tag: "",
        Remark: "",
        ClientDetail: "",
        CourseList: [],
        Grades: [],
      }
    },
    setNewClientForm(select){
      this.newclientform.SellerWechat = select.SellerWechat
    },
    onSubmit(){
      this.$refs.form.validate((valid) => {
        if (valid){
          // const req={
          //
          // }
          this.$store.dispatch('order/newpreorder',this.form).then(
            res => {
              if (res.code===200){
                this.$message({
                  message: res.msg,
                  type: 'success'
                })
                this.cleanform()
                this.localDialogVisible = false
              }else {
                this.$message({
                  message: res.msg,
                  type: 'error'
                })
              }
            }
          )
        }
      })
    },
    newclientdetail(detail) {
      this.newdetailinputerdialog = false
      this.newclientform = {
        ClientWechat: "",
        ClientType: "student",
        ClientSchool: "",
        Tag: "",
        Remark: "",
        ClientDetail: "",
        CourseList: [],
        Grades: []
      }
    },
    getClientsOptions(query) {
      this.optionsloading = true
      this.$store.dispatch('client/getmyclients', {searchstr: query}).then(res => {
        this.clientOptions = res.clients
        this.optionsloading = false
        if (this.clientOptions.length === 0){
          this.newclientform.ClientWechat = query
        }
      })
    },
    dialogClose() {
      this.$emit('closed');
    }
  }
}
</script>

